import { z } from 'zod'
import type { FireriskMetricPresetResult } from '#/domain/catalog/FireriskMetricPreset'

const FireriskMetricPresetRowDtoSchema = z.object({
  MetricId: z.string(),
  MetricName: z.string(),
  RiskType: z.string(),
  MinLevel: z.number(),
  MaxLevel: z.number(),
  DisplayOrder: z.number(),
})

export const FireriskMetricPresetResultDtoSchema = z
  .object({
    Added: z.array(FireriskMetricPresetRowDtoSchema),
    Skipped: z.array(FireriskMetricPresetRowDtoSchema),
  })
  .transform((raw): FireriskMetricPresetResult => ({
    added: raw.Added,
    skipped: raw.Skipped,
  }))

export type FireriskMetricPresetResultResponseDto = z.input<
  typeof FireriskMetricPresetResultDtoSchema
>

export function toDomain(
  raw: FireriskMetricPresetResultResponseDto,
): FireriskMetricPresetResult {
  return FireriskMetricPresetResultDtoSchema.parse(raw)
}
